/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_File_Format_LabelInputs */

const en_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Format`)
};

const fr_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format de fichier`)
};

const de_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiformat`)
};

const it_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato file`)
};

const ru_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат файла`)
};

const es_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de archivo`)
};

const zh_cn2_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件格式`)
};

const ja_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル形式`)
};

const hi_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल फ़ारमैट`)
};

const pt_pt2_transcript_export_file_format_label = /** @type {(inputs: Transcript_Export_File_Format_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato do arquivo`)
};

/**
* | output |
* | --- |
* | "File Format" |
*
* @param {Transcript_Export_File_Format_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_file_format_label = /** @type {((inputs?: Transcript_Export_File_Format_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_File_Format_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_file_format_label(inputs)
	if (locale === "de") return de_transcript_export_file_format_label(inputs)
	if (locale === "it") return it_transcript_export_file_format_label(inputs)
	if (locale === "ru") return ru_transcript_export_file_format_label(inputs)
	if (locale === "es") return es_transcript_export_file_format_label(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_file_format_label(inputs)
	if (locale === "ja") return ja_transcript_export_file_format_label(inputs)
	if (locale === "hi") return hi_transcript_export_file_format_label(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_file_format_label(inputs)
	return en_transcript_export_file_format_label(inputs)
});